/** 表格使用的相关函数 */

import { exportData, exportAllData } from "@/api/system/export";
import { warnMsg } from "@/utils/msgBox.ts";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";

// 导出数据
export const doExportData = (
  radio,
  excelHeader,
  selectVals,
  curPageData,
  allDataParams,
  allDataUrl
) => {
  if (radio === 1) {
    if (selectVals === null || selectVals.length === 0) {
      warnMsg("未选择数据，无法进行导出！");
      return;
    }
    // 选中数据
    exportData(getExportData(selectVals, excelHeader));
  } else if (radio === 2) {
    if (curPageData === null || curPageData.length === 0) {
      warnMsg("当前页无数据，无法进行导出！");
      return;
    }
    // 当前页数据
    exportData(getExportData(curPageData, excelHeader));
  } else if (radio === 3) {
    if (isNull(allDataUrl)) {
      warnMsg("获取全部数据url为空，无法进行导出！");
      return;
    }
    // 全部数据
    const headersKey = excelHeader.map((item) => item.prop);
    const headersValue = excelHeader.map((item) => item.label);
    exportAllData({
      json: JSON.stringify({
        params: allDataParams,
        url: allDataUrl,
        headersKey: headersKey.join(","),
        headersValue: headersValue.join(","),
      }),
    });
  }
};

// 获取导出数据
const getExportData = (exprotData, excelHeader) => {
  const labels = excelHeader.map((item) => item.label);
  const exportLabel = labels.join(",");
  const exportVal = [];
  exprotData.forEach((item) => {
    let valStrs = [];
    excelHeader.forEach((itemCol) => {
      valStrs.push(formatData(item, itemCol));
    });
    exportVal.push(valStrs.join(","));
  });
  return {
    json: JSON.stringify({ headersValue: exportLabel, record: exportVal }),
  };
};

// 格式化数据
const formatData = (itemVal, itemCol) => {
  let resStr = "";
  if (itemCol.type === "dict") {
    resStr = useCacheStore().getDictNameByPCodeSCode(
      itemCol.dictKey,
      itemVal[itemCol.prop]
    );
  } else if (itemCol.type === "dictList") {
    resStr = joinSymbol(
      "",
      useCacheStore().getDictNameByPCodeSCode(
        itemCol.dictKey,
        itemVal[itemCol.prop]
      ),
      ";"
    );
  } else if (itemCol.type === "cache") {
    resStr = useCacheStore().getCacheValue(
      itemCol.cacheKey,
      itemCol.cacheCode,
      itemCol.cacheValue,
      itemVal[itemCol.prop]
    );
  } else {
    if (itemVal[itemCol.prop] !== null) {
      resStr = itemVal[itemCol.prop];
    }
  }
  return resStr;
};

export const joinSymbol = (inStr, strArray, symbol) => {
  let outStr = inStr;
  strArray.forEach((strItem) => {
    if (strItem !== "") {
      if (outStr === "") {
        outStr = strItem;
      } else {
        outStr = outStr + symbol + strItem;
      }
    }
  });
  return outStr;
};
